import * as z from "zod";

export const getProductTitles = {
  name: "getProductTitles" as const,
  input: z.object({}),
  output: z.array(z.string()),
};
